import { BufferGeometry, Material } from "three";
import { getGeometryBounds2D } from "./openingGeometry";

interface BeamVerticalProps {
  geometry: BufferGeometry;
  material: Material;
  x: number;
  bottom: number;
  top: number;
  scaleX: number;
  visible: boolean;
}

export const BeamVertical = ({
  geometry,
  material,
  x,
  bottom,
  top,
  scaleX,
  visible,
}: BeamVerticalProps) => {
  const bounds = getGeometryBounds2D(geometry);
  const scaleY = (top - bottom) / (bounds.maxY - bounds.minY);

  return (
    <mesh
      visible={visible}
      geometry={geometry}
      material={material}
      position={[x, bottom - bounds.minY * scaleY, 0]}
      scale={[scaleX, scaleY, 1]}
      castShadow
      receiveShadow
    />
  );
};
